import { render, staticRenderFns } from "./esportsDistribution.vue?vue&type=template&id=541a308a&"
import script from "./esportsDistribution.vue?vue&type=script&lang=js&"
export * from "./esportsDistribution.vue?vue&type=script&lang=js&"
import style0 from "./esportsDistribution.vue?vue&type=style&index=0&id=541a308a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports